import { LEGAL_DOCUMENTS, formatLegalText } from '../content/legalDocuments'

/**
 * Рендерит текст юридического документа по id.
 * Параграфы разделяются по двойному переносу строки.
 * Плейсхолдеры можно подставить через values.
 */
export default function LegalDocContent({ docId, values }) {
  const doc = LEGAL_DOCUMENTS[docId]
  if (!doc || !doc.content || !doc.content.length) {
    return <p className="p" style={{ color: 'var(--gray)' }}>This document will be provided. Placeholder text.</p>
  }

  const raw = doc.content[0]
  const formatted = formatLegalText(raw, values)
  const paragraphs = formatted
    .split(/\n\n+/)
    .filter(Boolean)
    .map((para) => {
      // Конвертируем URL в кликабельные ссылки и сохраняем переносы строк.
      const withLinks = para.replace(
        /(https?:\/\/[^\s)]+)/g,
        '<a href="$1" target="_blank" rel="noreferrer">$1</a>'
      )
      return withLinks.replace(/\n/g, '<br />')
    })

  return (
    <div className="legal-doc-content" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
      {paragraphs.map((para, i) => (
        <p
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: para }}
          key={i}
          className="p"
          style={{ marginBottom: 12 }}
        />
      ))}
    </div>
  )
}

export function getLegalDocTitle(docId) {
  return LEGAL_DOCUMENTS[docId]?.title || docId
}

export function hasLegalDoc(docId) {
  return !!LEGAL_DOCUMENTS[docId]
}
